import { E__FlexibleReadmoreButton } from './e--flexible-readmore-button/E__FlexibleReadmoreButton';

export const Elements = {
    directives: {},
    modules: {
        E__FlexibleReadmoreButton
    }
};
